import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "nav-item"
};
const _hoisted_2 = {
  class: "sidenav-mini-icon"
};
const _hoisted_3 = {
  style: {
    "position": "relative",
    "display": "inline-block"
  }
};
const _hoisted_4 = {
  class: "sidenav-normal"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "position": "absolute",
    "top": "0",
    "right": "-15%",
    "width": "5px",
    "height": "5px",
    "background-color": "red",
    "border-radius": "50%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("li", _hoisted_1, [_createVNode(_component_router_link, {
    class: "nav-link",
    to: $props.to
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString($props.miniIcon), 1), _createElementVNode("span", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.text), 1), !$props.adminRead ? (_openBlock(), _createElementBlock("span", _hoisted_5)) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["to"])]);
}